<template>
  <div class="card-pos" v-show="isLoad">
    <div class="card">
      <div class="card-body h-100 w-75">
        <img class="p-0" :src="url" img-alt="Image" height="100" width="100"/>
      </div>
      <div class="card-footer text-center card-nowrap">
        <div class="card-text text-center text-truncate" v-b-tooltip :title="product.title">{{product.title}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "cardproduct",
  props: {
    product: Object
  },
  data() {
    return {
      url: "/img/product/icon_empthy_state.svg" ,
      isLoad: true
    };
  },
  mounted(){
    if( this.product.type == 'DEFAULT' ){
        this.url = require(`../assets/images/service/${this.product.image}`)
    }else{
        this.url = ( this.product.image ) ? this.product.image : "/img/product/icon_empthy_state.svg"
    }
  }
};
</script>
<style>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.lockcourier {
  pointer-events: none;
  opacity: 0.5;
}
.badge.badge-info.px-2.text-black.custom-line{
  white-space: normal;
}
</style>
